export function GameCardSkeleton() {
  return (
    <div className="bg-[#141414] border border-white/10 rounded-lg overflow-hidden animate-pulse">
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-white/5">
        <div className="flex gap-2">
          <div className="w-10 h-4 bg-white/5 rounded" />
          <div className="w-8 h-4 bg-white/5 rounded" />
        </div>
      </div>
      <div className="px-3 py-2 space-y-2">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded bg-white/5" />
          <div className="flex-1 h-4 bg-white/5 rounded" />
          <div className="w-8 h-5 bg-white/5 rounded" />
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded bg-white/5" />
          <div className="flex-1 h-4 bg-white/5 rounded" />
          <div className="w-8 h-5 bg-white/5 rounded" />
        </div>
      </div>
      <div className="px-3 py-1.5 border-t border-white/5">
        <div className="w-24 h-3 bg-white/5 rounded" />
      </div>
    </div>
  );
}

export function LeaderboardSkeleton({ rows = 8 }) {
  return (
    <div className="bg-[#141414] border border-white/10 rounded-xl overflow-hidden animate-pulse">
      <div className="px-4 py-3 border-b border-white/5">
        <div className="w-32 h-5 bg-white/5 rounded" />
      </div>
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-2.5 border-b border-white/5">
          <div className="w-6 h-4 bg-white/5 rounded" />
          <div className="w-5 h-5 rounded-full bg-white/5" />
          <div className="flex-1 h-4 bg-white/5 rounded" />
          <div className="w-12 h-4 bg-white/5 rounded" />
        </div>
      ))}
    </div>
  );
}
